import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  FiUsers,
  FiUser,
  FiMail,
  FiPhone,
  FiCalendar,
  FiChevronRight,
  FiHome,
} from "react-icons/fi";

import { getMyReferralLevels } from "../../store/slices/profile";

const LevelThree = () => {
  const dispatch = useDispatch();

  const {
    myReferralLevels = {},
    myReferralLevelsLoading,
    error,
  } = useSelector((state) => state.profile);


  useEffect(() => {
    dispatch(getMyReferralLevels());
  }, [dispatch]);


  const levelThreeData = myReferralLevels?.level3 || {};

  const levelThreeUsers = Array.isArray(levelThreeData?.users)
    ? levelThreeData.users
    : [];

  const levelThreeCount = levelThreeData?.count ?? levelThreeUsers.length;


  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return date;
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="gi-referral-page">
      <div className="gi-breadcrumb">
        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>My Network</span>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Level 3 Referral</span>
      </div>


      <section className="gi-referral-table-card">


        <div className="gi-referral-table-header">
          <div>
            <h2>Level 3 Referrals</h2>

            <p>Members referred through your Level 2 network</p>
          </div>

          <div className="gi-referral-count">
            <FiUsers />

            <span>{levelThreeCount} Members</span>
          </div>
        </div>


        <div className="gi-referral-table-wrapper">
          <table className="gi-referral-table">
            <thead>
              <tr>
                <th className="text-center">#</th>

                <th className="text-center">

                  Name
                </th>

                <th className="text-center">User ID</th>

                <th className="text-center">

                  Email
                </th>

                <th className="text-center">

                  Mobile Number
                </th>

                <th className="text-center">

                  Joined Date
                </th>

                <th className="text-center">Status</th>
              </tr>
            </thead>

            <tbody>

              {myReferralLevelsLoading && (
                <tr>
                  <td
                    colSpan="7"
                    className="gi-table-message"
                  >
                    Loading Level 3 referrals...
                  </td>
                </tr>
              )}


              {!myReferralLevelsLoading && error && (
                <tr>
                  <td
                    colSpan="7"
                    className="gi-table-message"
                  >
                    {error}
                  </td>
                </tr>
              )}


              {!myReferralLevelsLoading &&
                !error &&
                levelThreeUsers.length === 0 && (
                  <tr>
                    <td
                      colSpan="7"
                      className="gi-table-message"
                    >
                      No Level 3 referrals found
                    </td>
                  </tr>
                )}


              {!myReferralLevelsLoading &&
                !error &&
                levelThreeUsers.map((item, index) => {
                  const status =
                    item.joiningStatus ||
                    item.status ||
                    "PENDING";

                  return (
                    <tr
                      key={
                        item._id || item.userId || index
                      }
                    >

                      <td className="gi-referral-number text-center">
                        {String(index + 1).padStart(
                          2,
                          "0",
                        )}
                      </td>


                      <td>
                        <div className="text-center">


                          <div>
                            <strong>
                              {item.name || "-"}
                            </strong>


                          </div>
                        </div>
                      </td>


                      <td className="text-center">
                        <span className="gi-user-id">
                          {item.userId || "-"}
                        </span>
                      </td>

                      <td className="text-center">
                        <span className="gi-email-text">
                          {item.email || "-"}
                        </span>
                      </td>

                      <td className="text-center">
                        <span className="gi-mobile-text">
                          {item.mobileNo || "-"}
                        </span>
                      </td>

                      <td className="text-center">
                        <span className="gi-date-text">
                          {formatDate(
                            item.joinedAt ||
                            item.createdAt ||
                            item.joinedDate,
                          )}
                        </span>
                      </td>


                      <td className="text-center">
                        <span
                          className={`gi-status-badge ${String(
                            status,
                          ).toLowerCase()}`}
                        >

                          {status}
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default LevelThree;
